import { AudioLines } from 'lucide-react';
import { useState } from 'react';
import { AiGenerateDialog } from '@/components/ai-job/AiGenerateDialog';

interface GenerateTranslationVoiceoverActionProps {
  tourId: string;
  translationId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function GenerateTranslationVoiceoverAction({
  tourId,
  translationId,
  open,
  onOpenChange,
}: GenerateTranslationVoiceoverActionProps) {
  const [voice, setVoice] = useState<
    'alloy' | 'echo' | 'fable' | 'onyx' | 'nova' | 'shimmer'
  >('alloy');

  return (
    <AiGenerateDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Generate Voiceovers"
      submitLabel="Generate Voiceovers"
      description="Generate voiceovers for this translation. This will generate voiceovers for the translated description and conclusion using AI text-to-speech."
      endpoint={`/tours/${tourId}/translations/${translationId}/voiceovers`}
      invalidateKeys={[
        ['TourTranslation', translationId],
        ['Translation'],
      ]}
      successMessage="Translation voiceovers generated successfully"
      errorFallback="Failed to generate translation voiceovers"
      buildPayload={() => ({ voice })}
    >
      <div>
        <label htmlFor="voice" className="block text-sm font-medium mb-1">
          Voice <span className="text-destructive">*</span>
        </label>
        <select
          id="voice"
          required
          className="w-full px-3 py-2 border rounded-md"
          value={voice}
          onChange={(e) =>
            setVoice(
              e.target.value as 'alloy' | 'echo' | 'fable' | 'onyx' | 'nova' | 'shimmer',
            )
          }
        >
          <option value="alloy">Alloy</option>
          <option value="echo">Echo</option>
          <option value="fable">Fable</option>
          <option value="onyx">Onyx</option>
          <option value="nova">Nova</option>
          <option value="shimmer">Shimmer</option>
        </select>
      </div>
    </AiGenerateDialog>
  );
}

// Export the icon for use in the custom action
export const GenerateTranslationVoiceoverIcon = AudioLines;
